// Vietnamese. Keys omitted here fall back to English (see src/i18n/index.js).
// "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': 'Hủy',
  'common.submit': 'Gửi',
  'common.save': 'Lưu',
  'common.create': 'Tạo',
  'common.delete': 'Xóa',
  'common.close': 'Đóng',
  'common.retry': 'Thử lại',
  'common.confirm': 'Xác nhận',
  'common.areYouSure': 'Bạn có chắc không?',

  'chat.startConversation': 'Bắt đầu cuộc trò chuyện',
  'chat.inputPlaceholder': 'Nhập tin nhắn...',
  'chat.inputPlaceholderNoCredits': 'Đã hết tín dụng RPilot',
  'chat.creditsUsedUpFooter': 'Nhóm của bạn đã dùng hết tín dụng RPilot. Hãy bắt đầu cuộc trò chuyện mới sau khi tín dụng được gia hạn.',
  'chat.newChat': 'Cuộc trò chuyện mới',
  'chat.useSkill': 'Dùng kỹ năng',
  'chat.skills': 'Kỹ năng',
  'chat.loadingSkills': 'Đang tải kỹ năng…',
  'chat.noSkill': 'Không dùng kỹ năng',
  'chat.noSkillsAvailable': 'Không có kỹ năng nào',
  'chat.appliesNextMessage': 'Áp dụng từ tin nhắn tiếp theo của bạn',
  'chat.attachImage': 'Đính kèm hình ảnh',
  'chat.attachFile': 'Đính kèm tệp',
  'chat.fileTooLarge': 'Tệp quá lớn (tối đa {size})',
  'chat.uploadFailed': 'Tải lên thất bại',
  'chat.download': 'Tải xuống',
  'chat.recordVoice': 'Ghi âm',
  'chat.stopRecording': 'Dừng ghi âm',
  'chat.stop': 'Dừng',
  'chat.send': 'Gửi',
  'chat.thinking': 'Đang suy nghĩ…',
  'chat.thoughtProcess': 'Quá trình suy nghĩ',
  'chat.thinkingComplete': 'Đã suy nghĩ xong',
  'chat.toolUsedOne': 'Đã dùng 1 công cụ',
  'chat.toolsUsedCount': 'Đã dùng {count} công cụ',
  'chat.usedNames': 'Đã dùng {names}',
  'chat.usedToolsCount': 'Đã dùng {count} công cụ',
  'chat.running': 'đang chạy',
  'chat.details': 'Chi tiết',
  'chat.arguments': 'Tham số',
  'chat.result': 'Kết quả',
  'chat.error': 'Lỗi',
  'chat.done': 'Hoàn tất',
  'chat.openInNewTab': 'Mở trong thẻ mới',
  'chat.openInDocsSite': 'Mở trong trang tài liệu',
  'chat.noPageContent': 'Không có nội dung cho trang này.',
  'chat.goodResponse': 'Câu trả lời tốt',
  'chat.badResponse': 'Câu trả lời chưa tốt',
  'chat.whatWentWrong': 'Có gì chưa ổn?',
  'chat.optionalFeedback': 'Góp ý thêm (không bắt buộc)...',

  'approval.required': 'Cần phê duyệt',
  'approval.requiredCount': 'Cần phê duyệt — {count} hành động',
  'approval.approve': 'Phê duyệt',
  'approval.deny': 'Từ chối',
  'approval.approveAll': 'Phê duyệt tất cả',
  'approval.approveSelected': 'Phê duyệt mục đã chọn ({count})',
  'approval.denyAll': 'Từ chối tất cả',
  'approval.andMore': '…và {count} mục khác',
  'approval.approvedChip': 'Đã phê duyệt',
  'approval.deniedChip': 'Đã từ chối',
  'approval.timedOutChip': 'Hết thời gian',
  'approval.countApproved': '{count} đã phê duyệt',
  'approval.countDenied': '{count} đã từ chối',
  'approval.countTimedOut': '{count} hết thời gian',
  'approval.timedOut': 'hết thời gian',
  'approval.settled': 'đã xử lý',

  'header.expand': 'Mở rộng',
  'header.collapse': 'Thu gọn',
  'header.menu': 'Menu',
  'drawer.sessions': 'Phiên',
  'drawer.skills': 'Kỹ năng',
  'drawer.settings': 'Cài đặt',
  'drawer.noSessions': 'Chưa có phiên nào',
  'drawer.chatFallbackTitle': 'Cuộc trò chuyện {id}',
  'drawer.newSkill': 'Kỹ năng mới',
  'drawer.searchSkills': 'Tìm kỹ năng...',
  'drawer.noSkillsMatch': 'Không có kỹ năng nào khớp với tìm kiếm của bạn.',
  'drawer.noSkillsYet': 'Chưa có kỹ năng nào. Hãy tạo một kỹ năng để bắt đầu.',
  'drawer.mySkills': 'Kỹ năng của tôi',
  'drawer.builtIn': 'Có sẵn',
  'drawer.shared': 'Được chia sẻ',
  'drawer.showToolCalls': 'Hiển thị lệnh gọi công cụ',
  'drawer.autoAcceptEdits': 'Tự động chấp nhận chỉnh sửa',
  'drawer.darkMode': 'Chế độ tối',
  'drawer.version': 'Phiên bản',
  'drawer.versionCopied': 'Đã sao chép',

  'gate.meetTitle': 'Gặp gỡ RPilot',
  'gate.meetBody': 'RPilot là trợ lý AI của bạn dành cho RDrive. Hãy hỏi bất cứ điều gì về dữ liệu dự án bằng ngôn ngữ tự nhiên và nhận câu trả lời rõ ràng kèm liên kết trực tiếp. Dùng kỹ năng Agent để tự động hóa công việc và tinh gọn quy trình làm việc của bạn.',
  'gate.meetCta': 'Muốn dùng RPilot cho nhóm của bạn? Liên hệ đội ngũ bán hàng của chúng tôi',
  'gate.outOfCreditsTitle': 'Bạn đã hết tín dụng RPilot',
  'gate.outOfCreditsBody': 'Nhóm của bạn đã dùng hết tín dụng RPilot. Hãy liên hệ để gia hạn và tiếp tục ngay từ chỗ đã dừng.',
  'credits.title': 'Mức sử dụng tín dụng',
  'credits.loadFailed': 'Không thể tải mức sử dụng tín dụng.',
  'credits.active': 'Đang hoạt động',
  'credits.fallback': 'Dự phòng',
  'credits.exhausted': 'đã hết',
  'credits.noPools': 'Không có quỹ tín dụng',
  'credits.daily': 'Hằng ngày',
  'credits.weekly': 'Hằng tuần',
  'credits.monthly': 'Hằng tháng',
  'credits.dayShort': 'N',
  'credits.weekShort': 'T',
  'credits.monthShort': 'Th',
  'credits.usedNoLimit': '{label} — đã dùng {spent} (không giới hạn)',
  'credits.balanceLine': 'Số dư: {balance} tín dụng · đặt lại lúc nửa đêm {zone}',
  'credits.account': 'Tài khoản',
  'credits.scopeProject': 'Dự án',
  'credits.scopeTeam': 'Nhóm',
  'credits.scopeMixed': 'Hỗn hợp',
  'credits.scopePool': 'Quỹ',
  'credits.messageNotSent': 'Nhóm của bạn đã dùng hết tín dụng RPilot nên không thể gửi tin nhắn này. Cuộc trò chuyện của bạn đã được lưu.',
  'credits.contactUs': 'Liên hệ với chúng tôi',

  'sales.contactSales': 'Liên hệ bán hàng',
  'sales.requestReceived': 'Đã nhận yêu cầu ✓',
  'sales.submitAgain': 'Gửi lại',
  'sales.name': 'Họ tên',
  'sales.workEmail': 'Email công việc',
  'sales.companyTeam': 'Công ty / nhóm (không bắt buộc)',
  'sales.message': 'Lời nhắn (không bắt buộc)',
  'sales.nameRequired': 'Vui lòng nhập họ tên',
  'sales.emailRequired': 'Vui lòng nhập email công việc',
  'sales.emailInvalid': 'Vui lòng nhập địa chỉ email hợp lệ',
  'sales.thanks': 'Cảm ơn bạn — đội ngũ của chúng tôi sẽ sớm liên hệ.',
  'sales.alreadyReceived': 'Chúng tôi đã nhận được yêu cầu của bạn — chúng tôi sẽ sớm liên hệ.',
  'sales.genericError': 'Đã xảy ra lỗi. Vui lòng thử lại.',
  'sales.speakWithSales': 'Trao đổi với bộ phận bán hàng',
  'sales.salesChatPrefill': 'Xin chào, tôi muốn trao đổi với bộ phận bán hàng về RPilot cho nhóm của mình.',

  'skill.newSkill': 'Kỹ năng mới',
  'skill.editTitle': 'Chỉnh sửa — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'Đây là kỹ năng có sẵn do RDrive duy trì và không thể chỉnh sửa. Để tùy chỉnh cho dự án này, hãy tạo một kỹ năng được chia sẻ có cùng tên — kỹ năng đó sẽ được ưu tiên ở đây.',
  'skill.name': 'Tên',
  'skill.nameHint': 'định danh dạng kebab-case',
  'skill.nameRule': 'Phải ở dạng kebab-case (ví dụ: review-rfi)',
  'skill.shared': 'Chia sẻ',
  'skill.description': 'Mô tả',
  'skill.descriptionPlaceholder': 'Kỹ năng này làm gì và dùng khi nào',
  'skill.required': 'Bắt buộc',
  'skill.tags': 'Thẻ',
  'skill.tagsPlaceholder': 'Nhập rồi nhấn Enter',
  'skill.allowedTools': 'Công cụ được phép',
  'skill.allToolsAllowed': 'Cho phép mọi công cụ',
  'skill.instructions': 'Hướng dẫn (Markdown)',
  'skill.contentRequired': 'Vui lòng nhập nội dung',
  'skill.deleteTitle': 'Xóa kỹ năng',
  'skill.deleteMessage': 'Xóa kỹ năng "{name}"? Hành động này không thể hoàn tác.',

  'picker.selectLocation': 'Chọn vị trí',
  'picker.searchDrawings': 'Tìm bản vẽ...',
  'picker.planViewerFailed': 'Không thể tải trình xem bản vẽ',
  'picker.selectDrawing': 'Chọn một bản vẽ để xem',
  'picker.tapToPlace': 'Chạm vào ghim vị trí để đặt vấn đề',
  'picker.pinPlaced': 'Đã đặt ghim',

  'md.bold': 'Đậm',
  'md.italic': 'Nghiêng',
  'md.heading': 'Tiêu đề',
  'md.inlineCode': 'Mã nội dòng',
  'md.codeBlock': 'Khối mã',
  'md.link': 'Liên kết',
  'md.bulletList': 'Danh sách dấu đầu dòng',
  'md.numberedList': 'Danh sách đánh số',
  'md.blockquote': 'Trích dẫn',
  'md.nothingToPreview': 'Không có gì để xem trước',
}
